import Subheading from 'components/common/Subheading';
import ToggleButton from 'components/common/ToggleButton';
import { projectedServings } from 'helpers/servings';
import { FAMILY, HOME_CHEF_MEALS_PER_WEEK } from 'lib/constants';

import BestFitLabel from './BestFitLabel';

const containerText = {
  question: 'Number of Servings Per Recipe',
  subQuestion: 'Number of Recipes Per Week',
};

const FamilyBoxCustomizer = ({
  setWeeklyMeals,
  weeklyMeals,
  servings,
  setServings,
  boxRecommendations,
}) => {
  const servingOptions = Object.entries(projectedServings[FAMILY]).map(([value, display]) => ({
    value: Number(value),
    display,
  }));

  return (
    <>
      <section>
        <Subheading className="mb-1 max-w-md text-left" brandStylesOverrides="h5">
          {containerText.question}
        </Subheading>
        <div className="mb-8 flex flex-row text-center">
          <div
            className="grid w-full grid-cols-3 gap-x-2 gap-y-3"
            role="radiogroup"
            aria-label="Servings options"
          >
            {servingOptions.map(serving => (
              <ToggleButton
                id={serving.display}
                selected={serving.value === servings}
                handleClick={() => setServings(serving.value)}
                className="relative w-full px-6 py-3"
                type="refreshToggle"
                key={serving.display}
                aria-label={`${serving.display} servings${serving.value === boxRecommendations.recommendedServings ? ', Best Fit' : ''}`}
                role="radio"
              >
                {serving.value === boxRecommendations.recommendedServings && (
                  <BestFitLabel className="left-0 border-lemon-100 bg-lemon-70 bp1:left-4" />
                )}
                {serving.display}
              </ToggleButton>
            ))}
          </div>
        </div>
      </section>

      <section>
        <Subheading className="mb-4 max-w-md text-left" brandStylesOverrides="h5">
          {containerText.subQuestion}
        </Subheading>

        <div className="mb-8 flex flex-row text-center">
          <div
            className="grid w-full grid-cols-3 gap-x-2 gap-y-3"
            role="radiogroup"
            aria-label="Weekly meals options"
          >
            {HOME_CHEF_MEALS_PER_WEEK.map(numberOfMeals => (
              <ToggleButton
                id={numberOfMeals}
                selected={numberOfMeals === weeklyMeals}
                handleClick={() => setWeeklyMeals(numberOfMeals)}
                className="relative w-full px-6 py-3"
                type="refreshToggle"
                key={numberOfMeals}
                aria-label={`${numberOfMeals} recipes${numberOfMeals === boxRecommendations.recommendedMeals ? ', Best Fit' : ''}`}
                role="radio"
              >
                {numberOfMeals === boxRecommendations.recommendedMeals && (
                  <BestFitLabel className="left-0 border-lemon-100 bg-lemon-70 bp1:left-4" />
                )}
                {numberOfMeals}
              </ToggleButton>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

FamilyBoxCustomizer.propTypes = {
  weeklyMeals: PropTypes.number.isRequired,
  setWeeklyMeals: PropTypes.func.isRequired,
  servings: PropTypes.number.isRequired,
  setServings: PropTypes.func.isRequired,
  boxRecommendations: PropTypes.object.isRequired,
};

export default FamilyBoxCustomizer;
